import { Guess } from "@/typings/guess";
import { Step } from "@/typings/step";
import { getTodayString } from "@/utils/prompts";
import { isSuccess } from "@/utils/scoring";
import { useCallback, useState } from "react";

type Result = {
  date: string;
  guesses: Array<Guess>;
};

const StorageKey = "result";

function getTodaysResult() {
  const rawResult = localStorage.getItem(StorageKey);
  if (rawResult === null) {
    return null;
  }

  const jsonResult: Result = JSON.parse(rawResult);
  if (jsonResult.date !== getTodayString()) {
    return null;
  } else {
    return jsonResult.guesses;
  }
}

function getTodaysLastStep(todaysResult: Array<Guess> | null) {
  if (todaysResult === null || todaysResult.length === 0) {
    return null;
  }

  if (isSuccess(todaysResult[todaysResult.length - 1].score)) {
    return Step.Success;
  }

  if (todaysResult.length === 1) {
    return Step.RoundOneFail;
  }

  if (todaysResult.length === 2) {
    return Step.RoundTwoFail;
  }

  return Step.RoundThreeFail;
}

export function useTodaysResult() {
  const [todaysResult] = useState<Array<Guess> | null>(getTodaysResult());
  const [todaysLastStep] = useState<Step | null>(getTodaysLastStep(todaysResult));

  const storeTodaysResult = useCallback((guesses: Array<Guess>) => {
    localStorage.clear();
    localStorage.setItem(
      StorageKey,
      JSON.stringify({
        date: getTodayString(),
        guesses,
      })
    );
  }, []);

  return { todaysResult, todaysLastStep, storeTodaysResult };
}
